var _Path, _Path2, _Path3, _Path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#4285F4",
    d: "M22 11.788c0-.742-.068-1.454-.194-2.138H11.763v4.047h5.739c-.252 1.302-1.008 2.404-2.142 3.145v2.631h3.46C20.837 17.649 22 14.97 22 11.788"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#34A853",
    d: "M11.763 22c2.88 0 5.293-.931 7.057-2.527l-3.46-2.631c-.95.627-2.162 1.007-3.597 1.007-2.772 0-5.128-1.834-5.971-4.304H2.244v2.698C3.998 19.653 7.594 22 11.764 22"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FBBC05",
    d: "M5.792 13.536a6.2 6.2 0 0 1-.34-1.986c0-.694.127-1.359.34-1.985V6.867H2.244a10.15 10.15 0 0 0 0 9.366l2.763-2.109z"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "#EA4335",
    d: "M11.763 5.261c1.57 0 2.967.532 4.081 1.558l3.054-2.992C17.046 2.135 14.642 1.1 11.763 1.1c-4.168 0-7.765 2.347-9.52 5.767l3.549 2.698c.843-2.47 3.199-4.304 5.971-4.304"
  })));
};
export default SvgGoogle;